<button *ngFor="let n of slots" type="button" class="swatch-btn" [class.on]="selected === n" [disabled]="disabled" (click)="pick.emit(n)" [attr.aria-label]="'Colour ' + n">
  <span class="swatch ring" [style.border-color]="'var(--app-subregion-' + n + ')'"></span>
</button>
